import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'irembogov-custom-paragraph',
  templateUrl: './custom-paragraph.component.html',
  styleUrls: ['./custom-paragraph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomParagraphComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  paragraphText!: string;
  showLoader = false;

  ngOnInit(): void {
    // Get paragraph text from props
    this.paragraphText = this.field.props?.['paragraphText'] || '';

    // Check if loader should be displayed
    this.showLoader = this.field.props?.['showLoader'] || false;
  }
}
